import { Button, InlineError, Input, Spinner, Switch } from 'avo-ui'
import TabToggleList from 'components/commons/tab-toogle-list'
import icAddSquare from 'assets/images/ic-add-square.svg'
import UploadImage from 'components/commons/upload-image'
import Datepicker from 'components/commons/datepicker'
import Timepicker from 'components/commons/timepicker'
import moment from 'moment'

export const HeaderBanner = ({
    isShow,
    items,
    setItems,
    onChangeForm,
    onChangeItem,
    onAddNewItem,
    errorForm,
    isLoading,
    isLoadingUpload,
    isUpdating,
    onSubmit,
}) => {
    const getError = (key, index) => {
        const findError = errorForm?.header_banners_detail?.find((i) => i?.index === index && i?.key === key)
        return findError?.message
    }

    return (
        <div className={'flex flex-col space-y-6 px-9 py-4 overflow-auto'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex items-center justify-between border border-neutral-20 px-6 py-4 rounded-lg'}>
                        <p className={'font-semibold text-lg text-black-95'}>Header Banner</p>
                        <div className={'flex items-center space-x-6'}>
                            <p className={'font-semibold'}>{!isShow ? 'Hide' : 'Show'}</p>
                            <Switch
                                name={'is_show'}
                                checked={!!isShow}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.checked })}
                            />
                        </div>
                    </div>
                    <div className={'flex flex-col space-y-6'}>
                        {items?.map((item, index) => (
                            <TabToggleList
                                key={`header-banner-${index}`}
                                index={index}
                                title={`Header-Banner-Item-${index + 1}`}
                                content={
                                    <div className={'flex space-x-16'}>
                                        <div className={'flex-1 flex-col space-y-5'}>
                                            <div
                                                className={`flex flex-col ${(item?.desktop_image_url?.base64 || item?.desktop_image_url) && 'space-y-3'}`}
                                            >
                                                <div className={'font-semibold text-blue-90 required'}>
                                                    Header Banner Desktop (1366px x 30px)
                                                </div>
                                                <UploadImage
                                                    className={'w-fit'}
                                                    classNameImage={
                                                        '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                                    }
                                                    id={`header-banner-desktop-${index}`}
                                                    value={item?.desktop_image_url?.base64 || item?.desktop_image_url}
                                                    onChange={(value) =>
                                                        onChangeItem({
                                                            name: 'desktop_image_url',
                                                            value,
                                                            index,
                                                        })
                                                    }
                                                />
                                                <InlineError
                                                    className={'mt-2'}
                                                    message={getError('desktop_image_url', index)}
                                                />
                                            </div>
                                            <div className={'flex flex-col space-y-3'}>
                                                <div className={'font-semibold text-blue-90'}>Link Direction</div>
                                                <Input
                                                    className={'flex-1'}
                                                    name={'url'}
                                                    placeholder={'Masukkan link direction'}
                                                    value={item?.url}
                                                    onChange={(item) => onChangeItem({ ...item, index })}
                                                />
                                                <InlineError className={'mt-2'} message={getError('url', index)} />
                                            </div>
                                        </div>
                                        <div className={'flex-1 flex-col space-y-5'}>
                                            <div
                                                className={`flex flex-col ${(item?.mobile_image_url?.base64 || item?.mobile_image_url) && 'space-y-3'}`}
                                            >
                                                <div className={'font-semibold text-blue-90 required'}>
                                                    Header Banner Mobile (393px x 35px)
                                                </div>
                                                <UploadImage
                                                    className={'w-fit'}
                                                    classNameImage={
                                                        '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                                    }
                                                    id={`header-banner-mobile-${index}`}
                                                    value={item?.mobile_image_url?.base64 || item?.mobile_image_url}
                                                    onChange={(value) =>
                                                        onChangeItem({
                                                            name: 'mobile_image_url',
                                                            value,
                                                            index,
                                                        })
                                                    }
                                                />
                                                <InlineError
                                                    className={'mt-2'}
                                                    message={getError('mobile_image_url', index)}
                                                />
                                            </div>
                                            <div className={'flex flex-col space-y-3'}>
                                                <div className={'font-semibold text-blue-90'}>Waktu Aktif</div>
                                                <div className={'flex space-x-2'}>
                                                    <Datepicker
                                                        name={`published-date-${index}`}
                                                        className={'flex-1'}
                                                        value={item?.published_date}
                                                        minDate={moment()}
                                                        format={'YYYY-MM-DD'}
                                                        onChange={(value) =>
                                                            onChangeItem({
                                                                name: 'published_date',
                                                                value,
                                                                index,
                                                            })
                                                        }
                                                        isClearable
                                                    />
                                                    <Timepicker
                                                        className={'flex-1'}
                                                        name={'published_time'}
                                                        placeholder='Pilih Waktu'
                                                        value={item?.published_time}
                                                        disabled={!item?.published_date}
                                                        onChange={(item) => onChangeItem({ ...item, index })}
                                                    />
                                                </div>
                                                <InlineError
                                                    className={'mt-2'}
                                                    message={getError('published_at', index)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }
                                items={items}
                                setItems={setItems}
                                isDisableDelete={items?.length === 1}
                                isSorting
                            />
                        ))}
                        <InlineError className='mt-2' message={errorForm?.header_banners} />
                        <Button
                            className={'w-fit'}
                            type={'outline'}
                            icon={icAddSquare}
                            title={'Add New Item'}
                            onClick={onAddNewItem}
                        />
                    </div>
                    <div className={'flex py-3 justify-center'}>
                        <Button
                            className={'w-[200px]'}
                            loading={isLoadingUpload || isUpdating}
                            title={'Submit'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
